;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();type AgentSkillGroupPropertiesKeyParams = {
	propertyGroupIdsKey: string;
	workspaceId: string;
};

type AgentConfigRunKeyParams = {
	agentId: string;
	slug: string;
	workspaceId: string;
};

type AgentWorkspaceAgentKeyParams = {
	agentId: string;
	workspaceId: string;
};

export const agentQueryKeys = {
	actions: ({ agentId, workspaceId }: AgentWorkspaceAgentKeyParams) =>
		["agent-actions", workspaceId, agentId] as const,
	configRun: ({ agentId, slug, workspaceId }: AgentConfigRunKeyParams) =>
		["agent-config-run", workspaceId, agentId, slug] as const,
	configuredAgent: ({ agentId, workspaceId }: AgentWorkspaceAgentKeyParams) =>
		["configured-agent", workspaceId, agentId] as const,
	configuredAgentRuns: ({
		agentId,
		workspaceId,
	}: AgentWorkspaceAgentKeyParams) =>
		[
			...agentQueryKeys.configuredAgentRunsPrefix(workspaceId),
			agentId,
		] as const,
	configuredAgentRunsAll: ["configured-agent-runs"] as const,
	configuredAgentRunsPrefix: (workspaceId: string) =>
		[...agentQueryKeys.configuredAgentRunsAll, workspaceId] as const,
	configuredAgents: (workspaceId: string) =>
		["configured-agents", workspaceId] as const,
	definitions: (workspaceId: string) =>
		["agent-definitions", workspaceId] as const,
	skillCorporateEntities: (workspaceId: string) =>
		["skill-corporate-entities", workspaceId] as const,
	skillGlAccounts: ({
		filterKeyPart,
		workspaceId,
	}: {
		filterKeyPart: Record<string, string[]> | null;
		workspaceId: string;
	}) => ["skill-gl-accounts", workspaceId, filterKeyPart] as const,
	skillGroupProperties: ({
		propertyGroupIdsKey,
		workspaceId,
	}: AgentSkillGroupPropertiesKeyParams) =>
		["skill-group-properties", workspaceId, propertyGroupIdsKey] as const,
	skillPropertyGroups: (workspaceId: string) =>
		["skill-property-groups", workspaceId] as const,
	skills: ({ agentId, workspaceId }: AgentWorkspaceAgentKeyParams) =>
		["agent-skills", workspaceId, agentId] as const,
	skillVendors: (workspaceId: string) =>
		["skill-vendors", workspaceId] as const,
};

export const agentMutationKeys = {
	actionsInvoke: ["agents", "actions", "invoke"] as const,
	create: ["agents", "create"] as const,
	delete: ({ agentId, workspaceId }: AgentWorkspaceAgentKeyParams) =>
		[workspaceId, "agents", "delete", agentId] as const,
	draftActivate: ["agents", "draft", "activate"] as const,
	draftCreate: ["agents", "draft", "create"] as const,
	setupConfirm: ["agents", "setup", "confirm"] as const,
	setupEnrich: ["agents", "setup", "enrich"] as const,
	trigger: ({ agentId, workspaceId }: AgentWorkspaceAgentKeyParams) =>
		[workspaceId, "agents", "trigger", agentId] as const,
	update: ({ agentId, workspaceId }: AgentWorkspaceAgentKeyParams) =>
		[workspaceId, "agents", "update", agentId] as const,
	validateCreate: ["agents", "validate-create"] as const,
};
